
import { Component, Vue } from "vue-property-decorator";
import ForgotPassword from "../components/authentification/login/ForgotPassword.vue";

@Component({
  components: { ForgotPassword }
})
export default class App extends Vue {
  public metaInfo(): any {
    return {
      meta: [
        {
          name: "description",
          content:
            "Page de réinitialisation du mot de passe de l'application des Licences Nationales"
        }
      ],
      title: "Mot de passe oublié - Licences Nationales"
    };
  }

  allerAConnexion(): void {
    this.$store.dispatch("closeDisplayedMessage");
    this.$router.push({ name: "Login" });
  }
}
